
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.13 53.09V32a18.87 18.87 0 1137.74 0v21.09","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M56.25 13.79V5.6h7.5v8.19M50.56 35.97v17.5M60 35.97v17.5M69.44 35.97v17.5M60 0v5.33M41.23 36.43h37.54M30.41 72.91H89.6V108H30.41z"}}),_c('path',{attrs:{"d":"M50.81 107.92V90.85a9.19 9.19 0 0118.38 0v17.07M30.63 78.83H8.12V108h22.32M89.37 78.83h22.51V108H89.56M84.79 71.94V53.47H35.21v18.47","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M43.7 72.91v-5.03L60 60.27l16.3 7.61v5.03"}})])
          )
        }
      }
    